import { Component, Inject } from '@angular/core';
import { SCREEN_LAYOUT, ScreenLayout } from '../core/layout/layout.provider';
import { DataService } from '../data/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CashBoxOpenModalComponent } from './cash-box-open-modal.component';

@Component({
    selector: 'app-cash-box-closed-page',
    template: `
    <div class="d-flex h-100 w-100 flex-column justify-content-between">
      <div class="flex-grow-0 flex-shrink-1">
        <app-cart-header *ngIf="screenLayout === 'desktop'"></app-cart-header>
      </div>

      <div class="d-flex flex-column flex-shrink-1 overflow-hidden h-100 align-items-center justify-content-end p-5 pb-1">
        <div class="text-muted text-center pb-3" i18n>Die Kasse muss geöffnet werden, um Produkte zum Warenkorb hinzuzufügen.</div>
        <span class="material-icons text-success icon-small">expand_more</span>
        <span class="material-icons text-success icon-medium">expand_more</span>
        <span class="material-icons text-success icon-large">expand_more</span>
      </div>

      <div [class.bg-white]="screenLayout === 'mobile'" class="flex-grow-0 flex-shrink-1">
        <div class="w-100 d-flex align-items-center justify-content-center py-3 border border-top border-1">
          <button class="btn btn-lg btn-success text-white w-75 py-3" i18n (click)="openCashBoxOpenModal()">
            Kasse öffnen
          </button>
        </div>
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
      height: 100%;
      width: 100%;
    }

    .icon-small {
      font-size: 36px;
    }
    .icon-medium {
      font-size: 48px;
    }
    .icon-large {
      font-size: 80px;
    }

  `],
    standalone: false
})
export class CashBoxClosedPage {
  constructor(@Inject(SCREEN_LAYOUT) public screenLayout: ScreenLayout,
              private readonly modalService: NgbModal,
              public dataService: DataService) {
  }

  openCashBoxOpenModal() {
    this.modalService.open(CashBoxOpenModalComponent, {
      size: 'lg'
    });
  }

}
